module.exports = __webpack_public_path__ + "img/meeting-feedback-background.c4baab2d.png";